import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './Toast.css';

const Toast = ({ message, type = 'info', duration = 3000, onClose }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev - (100 / (duration / 100));
        if (newProgress <= 0) {
          return 0;
        }
        return newProgress;
      });
    }, 100);

    const timeout = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [duration, onClose, message, type]);

  const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const borderColor = type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#17a2b8';
  const bgColor = isDarkMode ? '#2d2d2d' : 'white';
  const textColor = isDarkMode ? '#e0e0e0' : '#333';
  const closeColor = isDarkMode ? '#b0b0b0' : '#666';

  // Se renderiza en document.body para que ningún contenedor de la página (ni un modal abierto)
  // lo tape: queda en la misma capa raíz que los modales de MUI y con z-index mayor.
  return ReactDOM.createPortal(
    <div role="status" aria-live="polite" style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      minWidth: '300px',
      background: bgColor,
      borderRadius: '8px',
      borderLeft: `4px solid ${borderColor}`,
      boxShadow: isDarkMode ? '0 4px 12px rgba(0, 0, 0, 0.5)' : '0 4px 12px rgba(0, 0, 0, 0.15)',
      overflow: 'hidden',
      // Por encima de los modales de MUI (theme.zIndex.modal = 13000), igual que snackbar.
      zIndex: 14000,
      animation: 'slideInRight 0.3s ease-out'
    }}>
      <style>{`
        @keyframes slideInRight {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px',
        gap: '12px'
      }}>
        <span style={{ flex: 1, fontSize: '14px', color: textColor }}>{message}</span>
        <button type="button" onClick={onClose} aria-label="Cerrar aviso" style={{
          background: 'none',
          border: 'none',
          fontSize: '24px',
          color: closeColor,
          cursor: 'pointer',
          padding: 0,
          width: '24px',
          height: '24px',
          lineHeight: '24px'
        }}>×</button>
      </div>
      <div style={{ height: '4px', background: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)' }}>
        <div style={{
          height: '100%',
          width: `${progress}%`,
          background: borderColor,
          transition: 'width 0.1s linear'
        }} />
      </div>
    </div>,
    document.body
  );
};

export default Toast;
